/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

// Dashboard example components

import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Some required packages for generate and print qr
import { StyleSheet } from "@react-pdf/renderer";

import { useReactToPrint } from "react-to-print";

// Utils

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Functions from store
import {
  calculatePacketDetails,
  calculatePacketWeight,
  createAsn,
  // updateActualQty,
  createDirectDemand,
  createDynamicColumn,
  createMultipleDownload,
  getBinsForPrint,
  getDeliveryPlant,
  getDocumentDownloadCenter,
  getDynamicColumn,
  getItemCodeByPO,
  getItemMaster,
  getItemsDetailsForASN,
  getPackageType,
  getPartNo,
  getPartNoForPlanner,
  getPlant,
  getPurchaseOrdersForDemand,
  getSingleDownload,
  getSubModulesByRoleId,
  getUnloadingPoint,
  getVendorCodes,
  getVendorsListForPlanner,
  uploadForDirectDemand,
} from "../../store";

// React-Select component and styling
import Select from "react-select";
import Config from "../../config/index";
import "../../index.css";

// Cookies
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ViewButton from "components/standardized-components/ViewButton";
import { addMinutes, format } from "date-fns";
import Cookies from "universal-cookie";

const cookies = new Cookies();

let desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: "fit-content",
  maxHeight: "90%",
  overflow: "auto",
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForCreateASN = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 1420 },
  height: "fit-content",
  maxWidth: "90%",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 3,
  overflow: "scroll",
};

// const styleForCategoryModal = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: 380, sm: 480, md: 800, lg: 1200, xl: 1200 },
//   height: "fit-content",
//   maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
//   overflow: "scroll",
//   color: "black",
//   boxShadow: 24,
//   p: 2,
//   pt: 3,
// };

const styleForCategoryModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 380, sm: 480, md: 800, lg: 1200, xl: 1200 },
  maxWidth: "90%",
  height: "fit-content",
  maxHeight: "90%",
  // border: "1px solid white",
  boxShadow: 24,
  p: 1,
  pt: 3,
  overflow: "auto",
};

const styleForDocument = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 340, sm: 340, md: 600, lg: 800, xl: 800 },
  // height: { xs: "70%", sm: "70%", md: "50%", lg: "90%", xl: "90%" },
  overflow: "auto",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styles = StyleSheet.create({
  page: {
    width: "100%",
    height: "100%",
    display: "flex",
    // flexDirection: "row",
    marginBottom: "50px",
    marginTop: "50px",
    // backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 2,
    padding: 2,
    flexGrow: 1,
  },
});

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const DocumentDownloadCenter = ({
  getDocumentDownloadCenter,
  getDocumentDownloadCenterReducer,
  getSingleDownload,
  getSingleDownloadReducer,
  createMultipleDownload,
  createDirectDemand,
  itemMaster,
  getItemMaster,
  getPartNoForPlanner,
  partNoForPlannerReducer,
  getPartNo,
  partNoReducer,
  getPlant,
  plantReducer,
  getPackageType,
  packageTypeReducer,
  createAsn,
  getVendorCodeReducer,
  getVendorCodes,
  calculatePacketDetails,
  packageDetailsReducer,
  getDeliveryPlant,
  getUnloadingPoint,
  deliveryPlantReducer,
  unloadingPointReducer,
  calculatePacketWeight,
  packetWeightReducer,
  getBinsForPrint,
  binsForPrintReducer,
  uploadForDirectDemand,

  getVendorsListForPlanner,
  vendorsListForPlannerReducer,
  updateActualQty,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getItemsDetailsForASN,
  getItemsDetailsForASNReducer,
  getPurchaseOrdersForDemand,
  getPurchaseOrdersForDemandReducer,
  getItemCodeByPO,
  getItemCodeByPOReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let user = cookies.get("loginDetailsForWMS");
  let roleName = user.data.roleName;
  let userId = user.data.userId;
  let roleId = user.data.roleId;
  let email = user.data.email;
  let jwtToken = user?.jwt;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  const subModuleId = "95d4fce1-fdbf-4869-a35b-ac3181f64a36";

  let demandModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "95d4fce1-fdbf-4869-a35b-ac3181f64a36",
  );

  let downloadSingleDocumentAccess = demandModule
    ? demandModule.actionId.includes("04ab5c9f-4573-45b1-a690-bc210020164f")
    : null;

  let downloadMultipleDocumentAccess = demandModule
    ? demandModule.actionId.includes("2664673b-14ee-4db7-849d-01918ba3b98c")
    : null;

  let viewAccess = demandModule
    ? demandModule.actionId.includes("e3f4e279-cbcb-4395-85db-ca11515c85d7")
    : null;

  let viewDocumentsAccess = demandModule
    ? demandModule.actionId.includes("15afbeff-6f4a-451f-83e9-df5548396147")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [uploadLoader, setUploadLoader] = useState(false);
  const [purchaseOrderNumberSelected, setPurchaseOrderNumberSelected] =
    useState("");
  const [partNoSelected, setPartNoSelected] = useState("");
  const [plantSelected, setPlantSelected] = useState("");
  const [vendorsListForPlannerSelected, setVendorsListForPlannerSelected] =
    useState("");

  const [asnQtyChange, setAsnQtyChange] = useState("");

  const [invoiceDate, setInvoiceDate] = useState("");

  const [invoiceNo, setInvoiceNo] = useState("");

  const [expiryDate, setExpiryDate] = useState("");

  const [batchNumber, setBatchNumber] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const isoStartDate = new Date(
      (startDate ? startDate : new Date()).getTime() -
        (startDate ? startDate : new Date()).getTimezoneOffset() * 60000,
    ).toISOString();

    setEndDate(isoStartDate);
  }, [startDate]);

  let today = new Date();

  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  let currentDate = yyyy + "-" + mm + "-" + dd;

  const [documentEmail, setDocumentEmail] = useState("");

  const [documentUserId, setDocumentUserId] = useState("");

  let baseUrl = Config.baseUrl;

  // Handle the document click and open the dialog
  const handleDocumentClick = (documentDetails) => {
    fetch(
      `${baseUrl}/vendor/download_center/single_doc?vendorId=${documentUserId}&file_name=${documentDetails?.name}&file_type=${documentDetails?.type}`,
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        window.open(data.url, "_blank");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    // getSingleDownload(
    //   documentEmail,
    //   documentDetails?.name,
    //   documentDetails?.type,
    //   jwtToken
    // ).then((res) => {
    //   if (res && res.data && res.data.url) {
    //     window.open(res.data.url, "_blank");
    //   }
    // });
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState("");
  const [isPDF, setIsPDF] = useState(false);

  // Handle the document click and open the dialog
  const handleDocumentClick2 = (documentDetails) => {
    fetch(
      `${baseUrl}/vendor/download_center/single_doc?vendorId=${documentUserId}&file_name=${documentDetails?.name}&file_type=${documentDetails?.type}`,
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        // If the S3 URL is not a direct PDF link, force it to open as PDF in iframe
        let url = data.url;

        if (url && url.endsWith("pdf")) {
          url = `https://docs.google.com/gview?url=${encodeURIComponent(
            url,
          )}&embedded=true`;
          setIsPDF(true);
          setSelectedDocumentUrl(url);
        }
        if (
          url.endsWith("jpeg") ||
          url.endsWith("jpg") ||
          url.endsWith("png")
        ) {
          setIsPDF(false);
          setSelectedDocumentUrl(url);
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);
          // Images load faster, so we can set loading to false immediately
        }
      })
      //   if (url && !url.endsWith(".pdf")) {
      //     url = `https://docs.google.com/gview?url=${encodeURIComponent(
      //       url
      //     )}&embedded=true`;
      //   }
      //   setSelectedDocumentUrl(url);
      // })
      .catch((error) => {
        console.error("Error:", error);
      });
    setOpenDialog(true);
  };

  // Handle dialog close
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setIsLoading(true);
    setIsPDF(true);
  };

  const getDocument = (documentDetails) => {
    // Helper function to format bytes to MB/KB
    function formatFileSize(bytes) {
      if (!bytes && bytes !== 0) return "";
      if (bytes >= 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + " MB";
      } else if (bytes >= 1024) {
        return (bytes / 1024).toFixed(2) + " KB";
      } else {
        return bytes + " B";
      }
    }

    return (
      <Card
        style={{
          borderRadius: 20,
          border: "1px solid #c7c7c7",
          padding: 20,
          background: "#fff",
          maxWidth: 700,
          boxShadow: "0 2px 8px rgba(16,30,54,0.04)",
          fontFamily: "inherit",
          marginLeft: "-25px",
          marginRight: "-25px",
          marginBottom: "-20px",
          marginTop: "-20px",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 16 }}
        >
          <svg
            width="36"
            height="36"
            fill="none"
            viewBox="0 0 36 36"
            style={{ marginRight: 16 }}
          >
            <rect width="36" height="36" rx="8" fill="#F4F4F7" />
            <path
              d="M12 11a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V11Zm2 0v14h8V11h-8Zm1 3h6v2h-6v-2Zm0 4h6v2h-6v-2Zm0 4h4v2h-4v-2Z"
              fill="#7B7B8B"
            />
          </svg>
          <div style={{ float: "right", marginLeft: "auto" }}>
            <span
              style={{
                background: "#FEECEC",
                color: "#E14D4D",
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 500,
                padding: "2px 10px",
                marginLeft: 2,
              }}
            >
              {documentDetails?.documentType?.toUpperCase()}
            </span>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div
            style={{
              fontWeight: 500,
              fontSize: 18,
              lineHeight: "28px",
              marginBottom: 8,
              color: "#303030",
            }}
          >
            {documentDetails?.keyName}{" "}
          </div>
          <span style={{ marginTop: "-8px" }}>
            {" "}
            <Tooltip title="View">
              <MDButton
                style={{ padding: 0 }}
                // color="info"
                variant="contained"
                size="large"
                onClick={() => handleDocumentClick2(documentDetails)}
                // style={{
                //   display: "flex",

                //   alignItems: "center",
                //   gap: 4,
                //   border: "1px solid #eee",
                //   borderRadius: 12,
                //   background: "#fff",
                //   fontWeight: 600,
                //   fontSize: 13,

                //   cursor: "pointer",
                //   boxShadow: "none",
                //   marginRight: "10px",
                //   color: "black",
                // }}
              >
                {/* <svg
                width="30"
                height="30"
                fill="none"
                viewBox="0 0 24 24"
                style={{ marginRight: 4 }}
              >
                <path
                  d="M12 5c-7 0-9 7-9 7s2 7 9 7 9-7 9-7-2-7-9-7zm0 12c-4.97 0-7.73-4.11-8.46-5C4.27 10.11 7.03 6 12 6s7.73 4.11 8.46 5c-.73.89-3.49 5-8.46 5zm0-9a4 4 0 100 8 4 4 0 000-8zm0 6.5A2.5 2.5 0 1112 9a2.5 2.5 0 010 5z"
                  fill="#222"
                />
              </svg> */}
                <Icon>visibility</Icon>
              </MDButton>
            </Tooltip>
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            color: "#7B7B8B",
            fontSize: 16,
            marginBottom: 24,
          }}
        >
          <span>
            {formatFileSize(
              typeof documentDetails?.size === "number"
                ? documentDetails.size
                : parseInt(documentDetails?.size, 10),
            )}
          </span>
        </div>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <MDButton
            disabled={!downloadSingleDocumentAccess}
            variant="contained"
            fullWidth
            size="small"
            onClick={() => handleDocumentClick(documentDetails)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              border: "1px solid #c7c7c7",
              borderRadius: 12,
              background: "#fff",
              fontWeight: 600,
              fontSize: 13,
              padding: "10px 20px",
              cursor: "pointer",
              boxShadow: "none",
              color: "#303030",
            }}
          >
            <svg
              width="25"
              height="20"
              fill="none"
              viewBox="0 0 20 20"
              style={{ marginRight: 4 }}
            >
              <path
                d="M10 3v10m0 0l-3.5-3.5M10 13l3.5-3.5M4 17h12"
                stroke="#222"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Download
          </MDButton>
        </div>
      </Card>
    );
  };

  useEffect(() => {
    viewAccess &&
      getDocumentDownloadCenter(
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
  }, [
    viewAccess,
    vendorsListForPlannerSelected,
    pageNo,
    rowsPerPage,
    searchObject,
  ]);

  useEffect(() => {
    getPurchaseOrdersForDemand(jwtToken);
  }, []);

  useEffect(() => {
    roleName !== "vendor" && getPartNoForPlanner(jwtToken);
  }, []);

  useEffect(() => {
    // roleName == "vendor" &&
    getPartNo(
      vendorsListForPlannerSelected
        ? vendorsListForPlannerSelected.email
        : email,
      jwtToken,
    );
  }, [userId, vendorsListForPlannerSelected]);

  useEffect(() => {
    // roleName == "vendor" &&
    getItemCodeByPO(purchaseOrderNumberSelected?.value, jwtToken);
  }, [purchaseOrderNumberSelected]);

  useEffect(() => {
    getPlant(jwtToken);
  }, []);

  const handleChangePartNoForPlanner = (selectedOption) => {
    setPartNoSelected(selectedOption);
  };

  const [partNoForPlannerOptions, setPartNoForPlannerOptions] = useState([]);

  useEffect(() => {
    let tempPartNoForPlannerOptions = [];
    let data = partNoForPlannerReducer.partNoForPlannerData.data
      ? partNoForPlannerReducer.partNoForPlannerData.data
      : [];
    data.map((partNo) => {
      tempPartNoForPlannerOptions.push({
        label: partNo.itemCode,
        value: partNo.itemCode,
      });
    });
    setPartNoForPlannerOptions(tempPartNoForPlannerOptions);
  }, [partNoForPlannerReducer]);

  const [partNoByPOOptions, setPartNoByPOOptions] = useState([]);

  useEffect(() => {
    let tempPartNoByPOOptions = [];
    let data = getItemCodeByPOReducer.itemCodeByPO.data
      ? getItemCodeByPOReducer.itemCodeByPO.data
      : [];

    data.map((partNo) => {
      tempPartNoByPOOptions.push({
        label: partNo.itemCode,
        value: partNo.itemCode,
      });
    });
    setPartNoByPOOptions(tempPartNoByPOOptions);
  }, [getItemCodeByPOReducer]);

  useEffect(() => {
    getVendorsListForPlanner(jwtToken);
  }, []);

  const [asnCode, setAsnCode] = useState("");
  const [packageType, setPackageType] = useState("");

  useEffect(() => {
    getBinsForPrint(asnCode, jwtToken);
  }, [asnCode]);

  const [partCode, setPartCode] = useState("");

  const handleChangePurchaseOrderNumber = (selectedOption) => {
    setPurchaseOrderNumberSelected(selectedOption);
  };

  const [purchaseOrderNumberOptions, setPurchaseOrderNumberOptions] = useState(
    [],
  );

  useEffect(() => {
    let tempPurchaseOrderNumberOptions = [];
    let data = getPurchaseOrdersForDemandReducer.purchaseOrdersForDemand.data
      ? getPurchaseOrdersForDemandReducer.purchaseOrdersForDemand.data
      : [];
    data.map((purchaseOrderNumber) => {
      tempPurchaseOrderNumberOptions.push({
        label: purchaseOrderNumber.purchaseOrderNumber,
        value: purchaseOrderNumber.purchaseOrderNumber,
      });
    });
    setPurchaseOrderNumberOptions(tempPurchaseOrderNumberOptions);
  }, [getPurchaseOrdersForDemandReducer]);

  useEffect(() => {
    if (roleName == "vendor") {
      setPurchaseOrderNumberSelected({
        label: purchaseOrderNumberOptions[0]?.label,
        value: purchaseOrderNumberOptions[0]?.value,
      });
    }
  }, [purchaseOrderNumberOptions]);

  const [demandId, setDemandId] = useState("");

  useEffect(() => {
    getPackageType(partCode, jwtToken);
  }, [partCode]);

  useEffect(() => {
    calculatePacketWeight(partCode, asnQtyChange, jwtToken);
  }, [partCode, asnQtyChange]);

  useEffect(() => {
    getDeliveryPlant(demandId, jwtToken);
  }, [demandId]);

  useEffect(() => {
    getUnloadingPoint(demandId, jwtToken);
  }, [demandId]);

  const [singleDeliveryPlantData, setSingleDeliveryPlantData] = useState("");
  const [singleUnloadingPointData, setSingleUnloadingPointData] = useState("");

  const [singleAsnPackageTypeData, setSingleAsnPackageTypeData] = useState("");

  const [singleAsnPackageWeightData, setSingleAsnPackageWeightData] =
    useState("");

  const [singleAsnPackageDetailsData, setSingleAsnPackageDetailsData] =
    useState({});

  useEffect(() => {
    let data = packageTypeReducer.packageTypeData.data
      ? packageTypeReducer.packageTypeData.data
      : [];

    setSingleAsnPackageTypeData(data.packaging);
  }, [packageTypeReducer]);

  // useEffect(() => {
  //   let data = packetWeightReducer.packetWeightData.data
  //     ? packetWeightReducer.packetWeightData.data
  //     : [];

  //   setSingleAsnPackageWeightData(data.packWeight);
  // }, [packetWeightReducer]);

  useEffect(() => {
    let data = deliveryPlantReducer.deliveryPlantData.data
      ? deliveryPlantReducer.deliveryPlantData.data
      : [];

    setSingleDeliveryPlantData(data.deliveryPlant);
  }, [deliveryPlantReducer]);

  useEffect(() => {
    let data = unloadingPointReducer.unloadingPointData.data
      ? unloadingPointReducer.unloadingPointData.data
      : [];

    setSingleUnloadingPointData(data.unloadingPoint);
  }, [unloadingPointReducer]);

  useEffect(() => {
    let data = packageDetailsReducer.packageDetailsData.data
      ? packageDetailsReducer.packageDetailsData.data
      : [];
    setSingleAsnPackageDetailsData(data);
  }, [packageDetailsReducer]);

  const handleChangePartNo = (selectedOption) => {
    setPartNoSelected(selectedOption);
  };

  const [partNoOptions, setPartNoOptions] = useState([]);

  useEffect(() => {
    let tempPartNoOptions = [];
    let data = partNoReducer.partNoData.data
      ? partNoReducer.partNoData.data
      : [];
    data.map((partNo) => {
      tempPartNoOptions.push({
        label: partNo.itemCode,
        value: partNo.itemCode,
      });
    });
    setPartNoOptions(tempPartNoOptions);
  }, [partNoReducer]);

  // useEffect(() => {
  //   if (roleName === "vendor") {
  //     setPartNoSelected({
  //       label: partNoByPOOptions[0]?.label,
  //       value: partNoByPOOptions[0]?.value,
  //     });
  //   }
  // }, [partNoByPOOptions]);

  const handleChangePlant = (selectedOption) => {
    setPlantSelected(selectedOption);
  };

  const [plantOptions, setPlantOptions] = useState([]);

  useEffect(() => {
    let tempPlantOptions = [];
    let data = plantReducer.plantData.data ? plantReducer.plantData.data : [];
    data.map((plant) => {
      tempPlantOptions.push({
        label: plant.plantCode,
        value: plant.plantCode,
      });
    });
    setPlantOptions(tempPlantOptions);
  }, [plantReducer]);

  useEffect(() => {
    if (plantOptions) {
      setPlantSelected({
        label: plantOptions[0]?.label,
        value: plantOptions[0]?.value,
      });
    }
  }, [plantOptions]);

  const handleChangeVendorsListForPlanner = (selectedOption) => {
    setVendorsListForPlannerSelected(selectedOption);
    setPartNoSelected("");
  };

  const [vendorsListForPlannerOptions, setVendorsListForPlannerOptions] =
    useState([]);

  useEffect(() => {
    let tempVendorsListForPlannerOptions = [];
    let data = vendorsListForPlannerReducer.vendorsListForPlannerData.data
      ? vendorsListForPlannerReducer.vendorsListForPlannerData.data
      : [];
    data.map((vendorsListForPlanner) => {
      tempVendorsListForPlannerOptions.push({
        label: vendorsListForPlanner.vendorName,
        value: vendorsListForPlanner.vendorCode,
        vendorId: vendorsListForPlanner.vendorUserId,
      });
    });
    setVendorsListForPlannerOptions(tempVendorsListForPlannerOptions);
  }, [vendorsListForPlannerReducer]);

  const packageTypeOptions = [
    { label: "Bin", value: "Bin" },
    // { label: "Can", value: "Can" },
    { label: "Carton", value: "Carton" },
    { label: "Container", value: "Container" },
  ];

  const [packageTypeSelected, setPackageTypeSelected] = useState("");
  const handleChangePackageType = (selectedOption) => {
    setPackageTypeSelected(selectedOption);
  };

  const [state, setState] = useState({
    columns: [
      { Header: "Supplier Name", accessor: "vendorName", align: "left" },

      {
        Header: "Created Date",
        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy",
              )
            : "";
        },
      },
      {
        Header: "Actions",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [categoryItemTable, setCategoryItemTable] = useState({
    columns: [
      { Header: "Document Name", accessor: "documentName", align: "left" },
      { Header: "File Type", accessor: "fileType", align: "left" },
      { Header: "Size", accessor: "size", align: "left" },
    ],
    rows: [],
  });

  const { columns: categoryColumns, rows: categoryRows } = categoryItemTable;

  const [categoryItems, setCategoryItems] = useState("");

  useEffect(() => {
    let tempCategoryItemsObj = [];

    let data = categoryItems ? categoryItems : [];

    const categoryItemsObj = {
      documentName: data?.incorporationCertificate?.name,
      qty: data.qty,
    };

    tempCategoryItemsObj.push(categoryItemsObj);

    setCategoryItemTable({ ...categoryItemTable, rows: tempCategoryItemsObj });
  }, [categoryItems]);

  // const [itemTable, setItemTable] = useState({
  //   columns: [
  //     { Header: "ASN Code", accessor: "asnCode", align: "left" },
  //     { Header: "Bin Code", accessor: "binCode", align: "left" },
  //     { Header: "QTY", accessor: "qty", align: "left" },
  //     // { Header: "Quantity", accessor: "quantity", align: "left" },
  //     // { Header: "NOB", accessor: "nob", align: "left" },
  //     // { Header: "LOT/Serial No", accessor: "lotSerialNo", align: "left" },
  //     // { Header: "Item Category", accessor: "itemCategory", align: "left" },
  //     { Header: "QR Code", accessor: "action", align: "center" },
  //   ],
  //   rows: [],
  // });

  // const { columns: itemColumns, rows: itemRows } = itemTable;

  const [isLoading, setIsLoading] = useState(true); // Loading state
  const handleIframeLoad = () => {
    setIsLoading(false);
    // Set loading to false once the iframe has loaded
  };

  const [buttonName, setButtonName] = useState("Submit");
  const [printData, setPrintData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openCategoryLineItemsModal, setOpenCategoryLineItemsModal] =
    useState(false);

  const handleOpenCategoryLineItemsModal = () => {
    setOpenCategoryLineItemsModal(true);
  };

  const handleCloseCategoryLineItemsModal = () => {
    setOpenCategoryLineItemsModal(false);
  };
  useEffect(() => {
    let tempDailyDemand = [];
    let data = getDocumentDownloadCenterReducer.documentDownloadCenter.data
      ? getDocumentDownloadCenterReducer.documentDownloadCenter.data
      : [];
    setLoading(getDocumentDownloadCenterReducer.loading);
    setPaginationObj(
      getDocumentDownloadCenterReducer.documentDownloadCenter.pagination,
    );
    data.map((singleData) => {
      let des = singleData?.itemDescription;
      let len = desLength;
      const formatDate = new Date(singleData.date);

      const dataObject = {
        privateKey: singleData.vendorId,
        vendorName: singleData.vendorName,
        documentName: singleData.documentName,
        fileType: singleData.fileType,
        size: singleData.size,
        cd: singleData.cd,
        vendorUserId: singleData.vendorUserId,
        action: (
          <>
            <ViewButton
              disabled={!viewDocumentsAccess}
              tooltip="View Documents"
              variant="gradient"
              color="info"
              iconOnly
              size="small"
              type="button"
              onClick={() => {
                handleOpenCategoryLineItemsModal(singleData);
                setCategoryItems(singleData.attachments);
                setDocumentEmail(singleData.email);
                setDocumentUserId(singleData.vendorUserId);
              }}
              style={{ marginRight: "5px", marginBottom: "5px" }}
            >
              <Icon>visibility</Icon>
            </ViewButton>
            <Tooltip title="Download Documents">
              <MDButton
                disabled={!downloadMultipleDocumentAccess}
                tooltip="Download"
                variant="gradient"
                color="success"
                size="small"
                iconOnly
                type="button"
                onClick={async () => {
                  let res = await createMultipleDownload(
                    [{ vendorId: singleData.vendorUserId }],
                    jwtToken,
                  );
                  console.log(res);
                  if (res && res.data && res.data.url) {
                    window.open(res.data.url, "_blank");
                  }
                }}
                style={{
                  marginRight: "5px",
                  marginBottom: "5px",
                  // background: "#22c55e",
                  // color: "white",
                }}
              >
                <Icon>download</Icon>
              </MDButton>
            </Tooltip>
          </>
        ),
      };
      tempDailyDemand.push(dataObject);
    });
    setState({ ...state, rows: tempDailyDemand });
  }, [getDocumentDownloadCenterReducer]);

  useEffect(() => {
    let tempBins = [];
    let data = binsForPrintReducer.binsForPrintData.data
      ? binsForPrintReducer.binsForPrintData.data
      : [];

    setPrintData(data);
  }, [binsForPrintReducer]);

  // const [showFilters, setShowFilters] = useState(false);

  // const showFiltersHandler = () => {
  //   setShowFilters(!showFilters);
  // };

  // const changeGrn = (selectedData) => {
  //   setGrnIdSelected(selectedData);
  // };

  // const changeWarehouse = (selectedData) => {
  //   setWarehouseIdSelected(selectedData);
  // };

  const DocumentsDownloadNotification = () =>
    toast.success("Documents Downloaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DocumentsDownloadFailureNotification = () =>
    toast.error("Something went wrong!", {
      position: "top-center",
      autoClose: 2000,
    });

  const [isErrorCreatePickupList, setIsErrorCreatePickupList] = useState(false);

  useEffect(() => {
    if (isErrorCreatePickupList) {
      setTimeout(() => {
        setIsErrorCreatePickupList(false);
      }, 3000);
    }
  }, [isErrorCreatePickupList]);

  const [openCreatePickupListModal, setOpenCreatePickupListModal] =
    useState(false);

  const [pickupListData, setPickupListData] = useState({});

  const handleOpenCreatePickupListModal = (data = {}) => {
    setPickupListData(data);
    setOpenCreatePickupListModal(true);
  };

  const handleCloseCreatePickupListModal = () => {
    setOpenCreatePickupListModal(false);
  };

  const createPickupListHandler = (event, data) => {
    handleOpenCreatePickupListModal(data);
  };

  const [selectedPickupListData, setSelectedPickupListData] = useState([]);
  const [uncheck, setUncheck] = useState(false);

  const PickupListData = (data) => {
    setSelectedPickupListData(data);
  };

  const onClickCreatePickupList = async () => {
    let transactionCode = [];

    selectedPickupListData.map((data) => {
      const object = {
        transactionCode: data.transactionNo,
      };
      transactionCode.push(object);
    });

    // let res = await createPickupList(transactionCode);

    // if (res.status) {
    //   handleCloseCreatePickupListModal();
    //   getCreatePickupList(warehouseIdSelected?.value);
    //   CreatePickupListSuccessNotification();
    // }
    // if (!res.status) {
    //   setIsErrorCreatePickupList(true);
    // }
  };

  const [fileForTestCertificate, setFileForTestCertificate] = useState({});

  const handleChangeForTestCertificate = (event) => {
    setFileForTestCertificate(event.target.files[0]);
  };

  const [fileForInvoiceFile, setFileForInvoiceFile] = useState({});

  const handleChangeForInvoiceFile = (event) => {
    setFileForInvoiceFile(event.target.files[0]);
  };

  //   const packageDetailsHandler = async () => {

  // let payload = {
  //   // asnQty: asnQtyChange,
  //   // partCode: partCode
  //   asnQty: "80",
  //   partCode: "M792.636.000"
  // }
  //     let res = await calculatePacketDetails(payload, jwtToken);

  //     if (res.status) {
  //       setSingleAsnPackageDetailsData(res.data);

  //     }
  //     if (!res.status) {

  //     }
  //   };

  const [openCreateASNModal, setOpenCreateASNModal] = useState(false);

  const [singleASNData, setSingleASNData] = useState({});
  const handleOpenCreateASNModal = (ActualQty = {}) => {
    setSingleASNData(ActualQty);

    setOpenCreateASNModal(true);
    setIsErrorCreateASN(false);
    setIsSuccessCreateASN(false);
  };
  const handleCloseCreateASNModal = () => {
    setOpenCreateASNModal(false);
    // formik.setValues(initialValues);
    // formik.setTouched({});
    // formik.setErrors({});
    setAsnQtyChange("");
    window.location.reload();
  };

  const [createAsnError, setCreateAsnError] = useState("");

  const [isErrorCreateASN, setIsErrorCreateASN] = useState(false);
  const [isSuccessCreateASN, setIsSuccessCreateASN] = useState(false);

  useEffect(() => {
    if (isErrorCreateASN) {
      setTimeout(() => {
        setIsErrorCreateASN(false);
      }, 3000);
    }
  }, [isErrorCreateASN]);

  useEffect(() => {
    if (isSuccessCreateASN) {
      setTimeout(() => {
        setIsSuccessCreateASN(false);
      }, 3000);
    }
  }, [isSuccessCreateASN]);

  const [printAsnDetailsPartCode, setPrintAsnDetailsPartCode] = useState("");
  const [printAsnDetailsInvoiceNo, setPrintAsnDetailsInvoiceNo] = useState("");
  const [printAsnDetailsTransporterName, setPrintAsnDetailsTransporterName] =
    useState("");
  const [printAsnDetailsVehicleNameplate, setPrintAsnDetailsVehicleNameplate] =
    useState("");
  const [printAsnDetailsTransporterType, setPrintAsnDetailsTransporterType] =
    useState("");
  const [printAsnDetailsLRNumber, setPrintAsnDetailsLRNumber] = useState("");
  const [printAsnDetailsPhoneNumber, setPrintAsnDetailsPhoneNumber] =
    useState("");

  const [openPrintASNModal, setOpenPrintASNModal] = useState(false);

  const handleClosePrintASNModal = () => {
    setOpenPrintASNModal(false);
  };

  const handleOpenPrintASNModal = () => {
    setOpenPrintASNModal(true);
  };

  const [show, setShow] = useState(false);

  const toggleSnackbar = () => setShow(!show);

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const ConfirmCnfAlertNotification = () =>
    toast.error("Please Go To Monthly Demand And Confirm Actual Qty", {
      position: "top-center",
      autoClose: false,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    setUploadLoader(true);

    let data = new FormData();

    data.append("file", uploadCsvData);
    data.append("userId", userId);

    let res = await uploadForDirectDemand(data, jwtToken);

    if (res.status) {
      setUploadLoader(false);

      getDocumentDownloadCenter(
        userId,
        purchaseOrderNumberSelected ? purchaseOrderNumberSelected.value : "",
        partNoSelected ? partNoSelected.value : "",
        plantSelected ? plantSelected.value : "",
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        roleName,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      setUploadLoader(false);
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };

  const [openUpdateActualQtyModal, setOpenUpdateActualQtyModal] =
    useState(false);
  const [
    singleMonthlyDemandDataForUpdate,
    setSingleMonthlyDemandDataForUpdate,
  ] = useState({});
  const handleOpenUpdateActualQtyModal = (ActualQty = {}) => {
    setSingleMonthlyDemandDataForUpdate(ActualQty);
    setOpenUpdateActualQtyModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateActualQtyModal = () => {
    setOpenUpdateActualQtyModal(false);

    formikForUpdate.setValues(initialValueForUpdate);
    formikForUpdate.setTouched({});
    formikForUpdate.setErrors({});
  };

  const [errorMsgForUpdateQty, setErrorMsgForUpdateQty] = useState("");

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    // departmentId: singleDepartmentDataForUpdate.departmentId,
    actualQty: singleMonthlyDemandDataForUpdate.actualQty,
    remark: singleMonthlyDemandDataForUpdate.remark,
  };

  const validationSchemaForUpdate = Yup.object({
    actualQty: Yup.number().required("Enter a valid Qty"),
  });

  const onSubmitForUpdate = async (values) => {
    let payload = {
      partCode: singleMonthlyDemandDataForUpdate.itemCode,
      planDate: singleMonthlyDemandDataForUpdate.date,
      planQty: values.actualQty,
    };

    // let res = await updateActualQty(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessForUpdate(true);
    //   setTimeout(() => {
    //     handleCloseUpdateActualQtyModal();
    //   }, 3000);

    //   getDocumentDownloadCenter(
    //     userId,
    //     partNoSelected ? partNoSelected.value : "",
    //     plantSelected ? plantSelected.value : "",
    //     vendorsListForPlannerSelected
    //       ? vendorsListForPlannerSelected.value
    //       : "",
    //     roleName,
    //     jwtToken
    //   );
    // }
    // if (!res.status) {
    //   setIsErrorForUpdate(true);
    //   setErrorMsgForUpdateQty(
    //     res.data.data.message ? res.data.data.message : res?.data?.data?.msg
    //   );
    // }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const [openCreateDemandModal, setOpenCreateDemandModal] = useState(false);

  const handleOpenCreateDemandModal = () => {
    setOpenCreateDemandModal(true);
    formikForCreateDemand.setValues(initialValueForCreateDemand);
    formikForCreateDemand.setTouched({});
    formikForCreateDemand.setErrors({});
    setSelectedVendorCode("");
    setSelectedItemCode("");
    getItemMaster(jwtToken);
    getVendorCodes(jwtToken);
  };

  const handleCloseCreateDemandModal = () => {
    setOpenCreateDemandModal(false);
  };

  const initialValueForCreateDemand = {
    demandDate: "",
    schqty: "",
    vendorCode: "",
    itemCode: "",
  };

  const validationSchemaForDemand = Yup.object({
    purchaseOrderNumber: Yup.string().required("Enter purchase order number"),
    purchaseOrderLineNumber: Yup.string().required(
      "Enter purchase order line number",
    ),
    unloadingPoint: Yup.string().required("Enter unloading point"),
    deliveryPlant: Yup.string().required("Enter delivery plant"),
    demandDate: Yup.date().required("Select the demand date"),
    vendorCode: Yup.object().required("Select a VendorCode"),
    itemCode: Yup.object().required("Select a ItemCode"),
    schqty: Yup.string().required("Enter a qty"),
  });

  const [selectedVendorCode, setSelectedVendorCode] = useState("");

  const handleVendorCodeChange = (selectedItemCode) => {
    setSelectedVendorCode(selectedItemCode);
  };

  const [vendorCodeOptions, setVendorCodeOptions] = useState([]);

  useEffect(() => {
    let tempVendorCodeOptions = [];
    let data = getVendorCodeReducer.vendors.data
      ? getVendorCodeReducer.vendors.data
      : [];

    data.map((item) => {
      tempVendorCodeOptions.push({
        label: item.vendorName,
        value: item.vendorCode,
      });
    });
    setVendorCodeOptions(tempVendorCodeOptions);
  }, [getVendorCodeReducer]);

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
        itemCode: item.itemCode,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");

  const [isErrorCreateNewDemand, setIsErrorCreateNewDemand] = useState(false);
  const [isSuccessCreateNewDemand, setIsSuccessCreateNewDemand] =
    useState(false);

  useEffect(() => {
    if (isErrorCreateNewDemand) {
      setTimeout(() => {
        setIsErrorCreateNewDemand(false);
      }, 3000);
    }
  }, [isErrorCreateNewDemand]);

  useEffect(() => {
    if (isSuccessCreateNewDemand) {
      setTimeout(() => {
        setIsSuccessCreateNewDemand(false);
      }, 3000);
    }
  }, [isSuccessCreateNewDemand]);

  const onSubmitForCreateDemand = async (values, { resetForm }) => {
    let payload = {
      itemCode: selectedItemCode?.itemCode,
      itemId: selectedItemCode?.value,
      date: values.demandDate,
      scheduleQty: values.schqty,
      userId: userId,
      vendorCode: selectedVendorCode?.value,
      unloadingPoint: values.unloadingPoint,
      deliveryPlant: values.deliveryPlant,
      purchaseOrderNumber: values.purchaseOrderNumber,
      purchaseOrderLineNumber: values.purchaseOrderLineNumber,
    };

    let res = await createDirectDemand(payload, jwtToken);

    if (res.status) {
      setIsSuccessCreateNewDemand(true);
      getDocumentDownloadCenter(pageNo, rowsPerPage, searchObject, jwtToken);
      setSelectedVendorCode("");
      setSelectedItemCode("");
      setTimeout(() => {
        handleCloseCreateDemandModal();
      }, 2000);

      resetForm();
    }
    if (!res.status) {
      setErrorMsgForCreate(res?.data?.data?.msg);
      setIsErrorCreateNewDemand(true);
    }
  };

  const formikForCreateDemand = useFormik({
    initialValues: initialValueForCreateDemand,
    validationSchema: validationSchemaForDemand,
    onSubmit: onSubmitForCreateDemand,
  });
  const [poNoLineNo, setPoNoLineNo] = useState("");
  const [selectedRejectData, setSelectedRejectData] = useState([]);
  const RejectForData = (data) => {
    setSelectedRejectData(data);
  };

  const onClickCreateRejectList = async () => {
    setLoading(true);
    let tempArray = [];
    selectedRejectData.map((data) => {
      const tempPayload = {
        vendorId: data.vendorUserId,
      };

      tempArray.push(tempPayload);
    });

    let payload = tempArray;

    let res = await createMultipleDownload(payload, jwtToken);

    if (res.status) {
      setLoading(false);
      setUncheck(!uncheck);
      if (res && res.data && res.data.url) {
        window.open(res.data.url, "_blank");
      }
      getDocumentDownloadCenter(
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setTimeout(() => {
        DocumentsDownloadNotification();
      }, 2000);
    }
    if (!res.status) {
      setLoading(false);
      DocumentsDownloadFailureNotification();
      // setIsErrorMsgForReject(res?.data?.data?.msg);
    }
  };

  console.log(selectedRejectData);

  const [disableButton, setDisableButton] = useState(false);

  // useEffect(() => {
  //   let value = selectedPublishData.some((data) => data.isPublished === 1);
  //   setDisableButton(value);
  // }, [selectedPublishData]);

  const headers = [
    {
      label: "date",
      key: "date",
    },
    {
      label: "scheduleQty",
      key: "scheduleQty",
    },
    {
      label: "vendorCode",
      key: "vendorCode",
    },
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "unloadingPoint",
      key: "unloadingPoint",
    },
    {
      label: "deliveryPlant",
      key: "deliveryPlant",
    },
    {
      label: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
    },
    {
      label: "purchaseOrderLineNumber",
      key: "purchaseOrderLineNumber",
    },
  ];

  const headers2 = [
    {
      label: "date",
      key: "date",
    },
    {
      label: "scheduleQty",
      key: "scheduleQty",
    },
    {
      label: "vendorCode",
      key: "vendorCode",
    },
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "unloadingPoint",
      key: "unloadingPoint",
    },
    {
      label: "deliveryPlant",
      key: "deliveryPlant",
    },
    {
      label: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
    },
    {
      label: "purchaseOrderLineNumber",
      key: "purchaseOrderLineNumber",
    },
  ];

  const csvLink = {
    filename: "Daily Demand.csv",
    headers: headers,
    data: [],
  };

  const csvLink2 = {
    filename: "Daily Demand.csv",
    headers: headers2,
    data: rows,
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getDocumentDownloadCenter(
        vendorsListForPlannerSelected
          ? vendorsListForPlannerSelected.value
          : "",
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <Grid item xs={8}>
                <MDBox
                  color="text"
                  px={2}
                  display="flex"
                  flexDirection="column"
                >
                  {/* <MDBox
                    display="flex"
                    marginLeft={0}
                    marginTop="12px"
                    marginBottom="5px"
                  > */}
                  {/* {createDemand && (
                      <CreateButton
                        tooltip="Create Demand"
                        color="info"
                        variant="contained"
                        type="button"
                        onClick={handleOpenCreateDemandModal}
                        style={{ marginRight: "10px" }}
                        iconOnly
                      >
                        <Icon>add</Icon>
                      </CreateButton>
                    )}
                    <CSVLink {...csvLink}>
                      <DownloadButton
                        tooltip="Download Template"
                        style={{ marginRight: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadButton>
                    </CSVLink>

                    {uploadDemand && (
                      <UploadButton
                        tooltip="Upload Demand"
                        style={{ marginRight: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="info"
                        iconOnly
                        onClick={uploadCsvFilterHandler}
                      >
                        <Icon>upload</Icon>
                      </UploadButton>
                    )}

                    {downloadDemand && (
                      <CSVLink {...csvLink2}>
                        <DownloadDataButton
                          tooltip="Download Demand List"
                          style={{ marginRight: "1rem" }}
                          type="button"
                          variant="outlined"
                          color="success"
                          iconOnly
                        >
                          <Icon>download</Icon>
                        </DownloadDataButton>
                      </CSVLink>
                    )}
                  </MDBox>
                  <MDBox mr={2}>
                    {uploadCsvFilter && (
                      <div>
                        <div>
                          <input
                            className="choose_file"
                            type="file"
                            accept=".csv"
                            onChange={(e) => {
                              setUploadCsvData(e.target.files[0]);
                            }}
                          />
                          <MDButton
                            disabled={
                              !uploadCsvData?.name ||
                              uploadCsvData?.type !== "text/csv"
                            }
                            variant="contained"
                            color="info"
                            style={{
                              marginLeft: "0",
                              marginTop: "0.3rem",
                              padding: 1,
                              height: "10px",
                            }}
                            type="button"
                            onClick={uploadCsvHandler}
                          >
                            Upload
                          </MDButton>
                        </div>
                        <div>
                          <span
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginLeft: "0px",
                              fontStyle: "italic",
                            }}
                          >
                            <strong>*</strong> Please upload
                            <strong>".csv"</strong> file only
                          </span>
                        </div>
                      </div>
                    )}
                  </MDBox> */}
                </MDBox>
              </Grid>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-5}
                mt={0}
              >
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <MDBox>
                      <MDBox
                        display="flex"
                        mt={2}
                        flexDirection={{ xs: "column", lg: "row" }}
                      >
                        <MDBox
                          width={{ xs: "250px", lg: "400px" }}
                          style={{ marginRight: "10px" }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Suppliers
                          </MDTypography>
                          <Select
                            isClearable
                            placeholder="Suppliers"
                            className="select-css-for-filter"
                            value={vendorsListForPlannerSelected}
                            options={vendorsListForPlannerOptions}
                            onChange={handleChangeVendorsListForPlanner}
                            autoComplete="off"
                          />
                        </MDBox>
                        {/* <MDBox
                          width={{ xs: "250px", lg: "400px" }}
                          style={{ marginRight: "10px" }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Onboarding Date
                          </MDTypography>
                          <DatePicker
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Start Date"
                            // maxDate={new Date()}
                            onChange={(date) => setStartDate(date)}
                            isClearable={true}
                            withPortal
                            // selectsStart
                            selected={startDate}
                            // startDate={startDate}
                            // endDate={endDate}
                          />
                        </MDBox> */}
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>

              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-6}
              >
                <MDBox>
                  <MDBox
                    flexDirection={{
                      xs: "column",
                      sm: "column",
                      md: "row",
                      lg: "row",
                      xl: "row",
                    }}
                    style={{ display: "flex" }}
                    mb={2}
                    ml={0}
                  ></MDBox>
                </MDBox>
              </MDBox>

              <MDBox pt={1}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  options={{ draggable: false }}
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  loading={loading}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  /* Table options */

                  /* Column reorder */
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  /* Meta */
                  subModuleId={subModuleId}
                  userId={userId}
                  hideColumns={[
                    "",
                    "unloadingPoint",
                    "deliveryPlant",
                    "purchaseOrderLineNumber",
                  ]}
                  selection={true}
                  selectionButtonClick={RejectForData}
                  uncheckProp={uncheck}
                  selectionButtonComponent={
                    // createPickuplistAccess &&
                    <Tooltip title="Download Documents">
                      {/* {publishAccess && ( */}
                      <MDButton
                        disabled={!downloadMultipleDocumentAccess}
                        color="success"
                        type="button"
                        style={{
                          marginTop: "0.5rem",

                          marginLeft: 5,
                        }}
                        onClick={(evt, data) =>
                          onClickCreateRejectList(evt, data)
                        }
                      >
                        Download
                      </MDButton>
                      {/* )} */}
                    </Tooltip>
                  }
                />
              </MDBox>

              <Modal
                open={openCategoryLineItemsModal}
                onClose={handleCloseCategoryLineItemsModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForCategoryModal}>
                  <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Documents
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseCategoryLineItemsModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            padding: "5px",
                            marginBottom: "5px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginBottom: "1rem" }} />

                  <MDBox pt={0} pb={0} px={0}>
                    <Grid container alignItems="center" spacing={2}>
                      {categoryItems.incorporationCertificate && (
                        <Grid item lg={4}>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography
                              variant="h6"
                              color="inherit"
                              // style={{ color: "grey", textAlign: "left" }}
                            >
                              {" "}
                              Incorporation Certificate{" "}
                            </MDTypography>{" "} */}
                              {getDocument(
                                categoryItems
                                  ? categoryItems.incorporationCertificate
                                  : "",
                              )}{" "}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}
                      {categoryItems.panCard && (
                        <Grid item lg={4}>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography
                              variant="h6"
                              color="inherit"
                              // style={{ color: "grey", textAlign: "left" }}
                            >
                              {" "}
                              Pan Card
                            </MDTypography> */}

                              {getDocument(
                                categoryItems ? categoryItems.panCard : "",
                              )}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}
                      {categoryItems.cancelledCheque && (
                        <Grid lg={4} item>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography
                              color="inherit"
                              variant="h6"
                              // style={{ color: "grey", textAlign: "left" }}
                            >
                              {" "}
                              Cancelled Cheque
                            </MDTypography> */}

                              {getDocument(
                                categoryItems
                                  ? categoryItems.cancelledCheque
                                  : "",
                              )}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}

                      {categoryItems.validLut && (
                        <Grid lg={4} item>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography
                              variant="h6"
                              color="inherit"
                              // style={{ color: "grey", textAlign: "left" }}
                            >
                              {" "}
                              Valid LUT
                            </MDTypography> */}

                              {getDocument(
                                categoryItems ? categoryItems.validLut : "",
                              )}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}

                      {categoryItems.gstRegistrationCertificate && (
                        <Grid item lg={4}>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography
                              variant="h6"
                              mt={0}
                              color="inherit"
                              // style={{ color: "grey", textAlign: "left" }}
                            >
                              {" "}
                              GST Registration Certificate
                            </MDTypography> */}

                              {getDocument(
                                categoryItems
                                  ? categoryItems.gstRegistrationCertificate
                                  : "",
                              )}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}
                      {categoryItems.sezApproval && (
                        <>
                          <Grid item lg={4}>
                            <MDBox component="form" role="form">
                              <MDBox>
                                {/* <MDTypography
                                  variant="h6"
                                  color="inherit"
                                  // style={{ color: "grey", textAlign: "left" }}
                                >
                                  {" "}
                                  SEZ Approval
                                </MDTypography> */}

                                {getDocument(
                                  categoryItems
                                    ? categoryItems.sezApproval
                                    : "",
                                )}
                              </MDBox>
                            </MDBox>
                          </Grid>
                        </>
                      )}
                      {categoryItems?.pfCertificate && (
                        <Grid lg={4} item>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography
                                variant="h6"
                                color="inherit"
                                // style={{ color: "grey", textAlign: "left" }}
                              >
                                {" "}
                                PF Certificate
                              </MDTypography> */}

                              {getDocument(
                                categoryItems
                                  ? categoryItems.pfCertificate
                                  : "",
                              )}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}
                      {categoryItems?.esiCertificate && (
                        <Grid lg={4} item>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography
                                variant="h6"
                                mt={0}
                                color="inherit"
                                // style={{ color: "grey", textAlign: "left" }}
                              >
                                {" "}
                                ESI Certificate
                              </MDTypography> */}

                              {getDocument(
                                categoryItems
                                  ? categoryItems.esiCertificate
                                  : "",
                              )}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}
                      {categoryItems?.tdsLowerDeductionCertificate && (
                        <Grid lg={4} item>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography
                                variant="h6"
                                color="inherit"
                                // style={{ color: "grey", textAlign: "left" }}
                              >
                                {" "}
                                TDS Lower Deduction Certificate
                              </MDTypography> */}

                              {getDocument(
                                categoryItems
                                  ? categoryItems.tdsLowerDeductionCertificate
                                  : "",
                              )}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}
                      {categoryItems?.msmeCertificate && (
                        <Grid lg={4} item>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography variant="h6" color="inherit">
                                {" "}
                                MSME Certificate
                              </MDTypography> */}

                              {getDocument(
                                categoryItems
                                  ? categoryItems.msmeCertificate
                                  : "",
                              )}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}

                      {categoryItems?.contract && (
                        <Grid lg={4} item>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography variant="h6" color="inherit">
                                {" "}
                                MSME Certificate
                              </MDTypography> */}

                              {getDocument(
                                categoryItems ? categoryItems.contract : "",
                              )}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}

                      {categoryItems?.other && (
                        <Grid lg={4} item>
                          <MDBox component="form" role="form">
                            <MDBox>
                              {/* <MDTypography variant="h6" color="inherit">
                                {" "}
                                MSME Certificate
                              </MDTypography> */}

                              {getDocument(
                                categoryItems ? categoryItems.other : "",
                              )}
                            </MDBox>
                          </MDBox>
                        </Grid>
                      )}
                    </Grid>
                  </MDBox>
                </MDCard>
              </Modal>

              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle>Document Preview</DialogTitle>
                <DialogContent>
                  {/* <iframe
                    src={selectedDocumentUrl}
                    title="Document Preview"
                    style={{ width: '100%', height: '400px', border: 'none' }}
                  /> */}

                  <Card
                    sx={{
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.15)",
                      transition: "transform 0.3s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.02)",
                      },
                      width: "100%",
                      maxWidth: "1000px",
                    }}
                  >
                    {isLoading && (
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <CircularProgress />
                      </div>
                    )}

                    {isPDF ? (
                      <iframe
                        src={selectedDocumentUrl}
                        title="VIEW"
                        width="100%"
                        height="800px"
                        style={{
                          border: "none",
                          borderRadius: "16px",
                          boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.2)",

                          position: "relative",
                        }}
                        onLoad={handleIframeLoad} // Handle iframe load event
                      />
                    ) : (
                      <img
                        src={selectedDocumentUrl}
                        alt="VIEW"
                        width="100%"
                        style={{
                          borderRadius: "16px",
                          boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.2)",
                          transition: "all 0.3s ease-in-out",
                        }}
                      />
                    )}
                  </Card>
                </DialogContent>

                <DialogActions
                  sx={{ padding: "16px", justifyContent: "center" }}
                >
                  <MDButton
                    onClick={handleCloseDialog}
                    color="primary"
                    variant="contained"
                    sx={{
                      fontSize: "1rem",
                      padding: "8px 24px",
                      backgroundColor: "#007BFF",
                      "&:hover": {
                        backgroundColor: "#0056b3",
                      },
                    }}
                  >
                    Close
                  </MDButton>
                </DialogActions>
              </Dialog>
            </Card>
          </Grid>
        </Grid>
        {uploadLoader ||
          (loading && (
            <Backdrop
              sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          ))}
        <Footer />

        <ToastContainer />
      </MDBox>
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getDocumentDownloadCenterReducer: state.getDocumentDownloadCenterReducer,
    getSingleDownloadReducer: state.getSingleDownloadReducer,
    itemMaster: state.itemMaster,
    partNoForPlannerReducer: state.partNoForPlannerReducer,
    partNoReducer: state.partNoReducer,
    plantReducer: state.plantReducer,
    vendorsListForPlannerReducer: state.vendorsListForPlannerReducer,
    packageTypeReducer: state.packageTypeReducer,
    packageDetailsReducer: state.packageDetailsReducer,
    deliveryPlantReducer: state.deliveryPlantReducer,
    unloadingPointReducer: state.unloadingPointReducer,
    packetWeightReducer: state.packetWeightReducer,
    binsForPrintReducer: state.binsForPrintReducer,
    getVendorCodeReducer: state.getVendorCodeReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getItemsDetailsForASNReducer: state.getItemsDetailsForASNReducer,
    getPurchaseOrdersForDemandReducer: state.getPurchaseOrdersForDemandReducer,
    getItemCodeByPOReducer: state.getItemCodeByPOReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getDocumentDownloadCenter: (
      vendoCode,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getDocumentDownloadCenter(
          vendoCode,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    getSingleDownload: (email, name, type, jwtToken) =>
      dispatch(getSingleDownload(email, name, type, jwtToken)),
    createMultipleDownload: (payload, jwtToken) =>
      dispatch(createMultipleDownload(payload, jwtToken)),
    uploadForDirectDemand: (payload, jwtToken) =>
      dispatch(uploadForDirectDemand(payload, jwtToken)),
    getBinsForPrint: (asnCode, jwtToken) =>
      dispatch(getBinsForPrint(asnCode, jwtToken)),
    getPartNoForPlanner: (jwtToken) => dispatch(getPartNoForPlanner(jwtToken)),
    getPartNo: (userId, jwtToken) => dispatch(getPartNo(userId, jwtToken)),
    getPlant: (jwtToken) => dispatch(getPlant(jwtToken)),
    getVendorsListForPlanner: (jwtToken) =>
      dispatch(getVendorsListForPlanner(jwtToken)),
    getPackageType: (partCode, jwtToken) =>
      dispatch(getPackageType(partCode, jwtToken)),
    calculatePacketWeight: (partCode, asnQtyChange, jwtToken) =>
      dispatch(calculatePacketWeight(partCode, asnQtyChange, jwtToken)),
    getUnloadingPoint: (id, jwtToken) =>
      dispatch(getUnloadingPoint(id, jwtToken)),
    getDeliveryPlant: (id, jwtToken) =>
      dispatch(getDeliveryPlant(id, jwtToken)),
    createAsn: (payload, jwtToken) => dispatch(createAsn(payload, jwtToken)),
    calculatePacketDetails: (asnQty, partCode, userId, jwtToken) =>
      dispatch(calculatePacketDetails(asnQty, partCode, userId, jwtToken)),

    // updateActualQty: (payload, jwtToken) =>
    //   dispatch(updateActualQty(payload, jwtToken)),
    createDirectDemand: (payload, jwtToken) =>
      dispatch(createDirectDemand(payload, jwtToken)),
    getVendorCodes: (jwtToken) => dispatch(getVendorCodes(jwtToken)),
    getItemsDetailsForASN: (payload, jwtToken) =>
      dispatch(getItemsDetailsForASN(payload, jwtToken)),
    getPurchaseOrdersForDemand: (jwtToken) =>
      dispatch(getPurchaseOrdersForDemand(jwtToken)),
    getItemCodeByPO: (poNo, jwtToken) =>
      dispatch(getItemCodeByPO(poNo, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapStateToDispatch,
)(DocumentDownloadCenter);
